import { request } from '../helpers/request';
import { Language } from '../helpers/types';

export const languagesApi = {
  list: (activeOnly = true) =>
    request<Language[]>('/languages', {
      params: { activeOnly },
    }),
};
